import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { Injectable, inject } from '@angular/core';
import * as actions from './rfr-mon-stack.actions';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { spxToasterActions, SpxToasterAutoCloseSpeedEnum } from '@softpak/components/spx-toaster';

import { ApiRfrMethod } from 'src/app/api/api-methods.rfr';
import { RfrMonStackResponseI } from 'src/app/api/rfr-mon-stack/rfr-mon-stack.result.int';

@Injectable()
export class RfrMonStackEffects {
  private readonly actions$ = inject(Actions);
  private readonly sharedGenericService = inject(SharedGenericService);


  load$ = createEffect(() =>
    this.actions$.pipe(ofType(actions.load),
      mergeMap((params) => this.sharedGenericService.invoke(ApiRfrMethod.rfrMonStack, params.query).pipe(
        map((data: RfrMonStackResponseI) => actions.received({ data })),
        catchError((error: SharedErrorObjectI) => [actions.error({ messageText: error.message })])
      ))
    ));

  onError$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.error),
    mergeMap(action => [
      spxToasterActions.createError({
        autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
        messageText: action.messageText,
      }),
    ]))
  );

  afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.received),
    mergeMap(() => [
      // actions.CREATE_SUCCESS({
      //     messageText: `Appointment ${result.data.piVBSBookingNr} added`,
      //     autoClose: SpxToasterAutoCloseSpeedEnum.SLOW,
      // }),
    ]))
  );
}
